class EuregioCartUpsell extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loaded === 'true') return;
    this.dataset.loaded = 'true';
    this.loadRecommendations();
  }

  async loadRecommendations() {
    const productId = this.dataset.productId;
    if (!productId) return;

    const url = new URL(this.dataset.recommendationsUrl, window.location.origin);
    url.searchParams.set('section_id', 'euregio-cart-upsell');
    url.searchParams.set('product_id', productId);
    url.searchParams.set('limit', '2');
    url.searchParams.set('intent', 'complementary');

    try {
      const response = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const markup = await response.text();
      const documentFragment = new DOMParser().parseFromString(markup, 'text/html');
      const results = documentFragment.querySelector('[data-ets-cart-upsell-results]');
      const destination = this.querySelector('[data-ets-cart-upsell-destination]');

      if (!results || !results.children.length || !destination) return;

      destination.replaceChildren(...results.cloneNode(true).childNodes);
      this.hidden = false;
    } catch (_error) {
      this.hidden = true;
    }
  }
}

if (!customElements.get('euregio-cart-upsell')) {
  customElements.define('euregio-cart-upsell', EuregioCartUpsell);
}
